import { routeColor } from '@vitals/shared';
import { bulletTextColor } from '../layers/bullets.js';
import { routeBulletPresentation } from '../routeBulletPresentation.js';

/**
 * Build a DOM MTA route "bullet" — a filled circle in the line's official color
 * with its designation centered. Single source of truth for color/label/text is
 * shared with the map's sprite atlas (routeColor, bulletLabel, bulletTextColor),
 * so a bullet in the vitals strip matches the bullet on the map exactly.
 *
 * XSS-safe: label comes from a fixed route table, never feed text, and is set via
 * textContent regardless.
 */
export function createRouteBullet(routeId: string): HTMLElement {
  const el = document.createElement('span');
  const presentation = routeBulletPresentation(routeId);
  el.className = `route-bullet route-bullet--${presentation.shape}`;
  const [r, g, b] = routeColor(presentation.id);
  el.style.color = bulletTextColor(routeId);
  const label = presentation.label;

  const face = document.createElement('span');
  face.className = 'route-bullet__face';
  face.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
  const labelEl = document.createElement('span');
  labelEl.className = 'route-bullet__label';
  labelEl.textContent = label;
  face.appendChild(labelEl);
  el.appendChild(face);

  el.title = `${presentation.descriptor} line`;
  return el;
}
